import React, { useState } from 'react'
import { Button } from 'antd'
import { ReactComponent as EditIcon } from '../../../asserts/icon/client/ic_edit.svg'
import EditableText from '../comp/EditableText'
import { isDarkDeck } from '../../../utils/constant'

export default function StepItem({
  editabled,
  field,
  title,
  placeholder,
  icon,
  color,
  value,
  onChange,
  isAIGenerated = false,
  arDetail,
  person
}) {
  const [editing, setEditing] = useState(false)
  const branded = isDarkDeck()
  const titleColor = branded ? '#ffffff' : color
  const refineBtnColor = branded ? '#c5beb3' : '#264382'
  return (
    <div className="step-item">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {icon}
          <div
            className="step-title"
            style={{ color: titleColor, fontSize: '18px', marginLeft: '16px', fontWeight: 600 }}
          >
            {title}
          </div>
        </div>

        {!editing && editabled && (
          <Button
            type="text"
            onClick={() => setEditing(true)}
            icon={
              <EditIcon
                style={{
                  marginRight: '8px',
                  display: 'inline-block',
                  verticalAlign: 'middle'
                }}
              />
            }
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <span
              style={{ display: 'inline-block', verticalAlign: 'middle', color: refineBtnColor }}
            >
              {isAIGenerated ? 'Refine with AI' : 'Edit'}
            </span>
          </Button>
        )}
      </div>

      <EditableText
        className="editor-section"
        value={value}
        editing={editing}
        placeholder={editabled ? placeholder : ''}
        setEditing={setEditing}
        onSave={(text) => onChange(text, field)}
        onAutosave={(text) => onChange(text, field)}
        arDetail={arDetail}
        person={person}
        allowAIRefinement={isAIGenerated}
        recommendationType={title.toLowerCase()}
      />
    </div>
  )
}
